import AuthenticationWrapper from 'modules/authentication/AuthenticationWrapper';
import LoginPage from 'modules/authentication/LoginPage';
import OrgList from 'modules/authentication/OrgList';
import InvitePage from 'modules/authentication/InvitePage';

import ForgotPasswordPage from 'modules/authentication/ForgotPasswordPage';
import ResetPasswordPage from 'modules/authentication/ResetPasswordPage';
import SecurityVerificationPage from 'modules/authentication/SecurityVerificationPage';
import { CheckAuth } from './RouteGuard';

const AuthenticationRoutes = (isUserLoggedIn: boolean): any => ({
  path: '/',
  element: <AuthenticationWrapper />,
  children: [
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'orgs',
      element: CheckAuth(isUserLoggedIn, <OrgList />),
    },
    {
      path: 'team/invite/:invitationId',
      element: <InvitePage />,
    },
    // {
    //     path: 'sign-up',
    //     element: <SignupPage />,
    // },
    {
      path: 'forgot-password',
      element: <ForgotPasswordPage />,
    },
    {
      path: '/password/reset/:uniqueId',
      element: <ResetPasswordPage />,
    },
    {
      path: 'security-verification',
      element: <SecurityVerificationPage />,
    },

    // {
    //     path: '',
    //     element: <Navigate to="/login" />,
    // },
  ],
});

export default AuthenticationRoutes;
